"use client";

// import { Box } from "@fastlooptech/layout-components";
import { lazy, ReactNode, useEffect, useState } from "react";
import classNames from "classnames";
// import { Video } from "@/components/Video/Video";
import { Box } from "@/layouts/LayoutComponents";
import { ImageType } from "@/types/app.type";
import dynamic from "next/dynamic";

// const Video = lazy(()=> import("@/components/Video/Video"));
const Video = dynamic(() => import("@/components/Video/Video"), {
  ssr: false,
  // loading: () => <img src="data:image/jpeg;base64,/9j/4AAQSk..." alt="loading..." /> 
});
// const Box = lazy(()=> import("@/layouts/LayoutComponents"), {
//   ssr: false
// })

export interface LandingDesktopProps {
  /**
   * The heading of the Landing.
   * @type ReactNode
   * @required
   */
  heading: ReactNode;
  /**
   * The video source used as background of the Landing.
   * @type string
   * @required
   */
  video: string;
  mobileVideo: string;
  /**
   * The images source the Card.
   * @type ImageType[]
   * @optional
   */
  image?: ImageType;
  /**
   * The video minimum height.
   * @type boolean
   * @optional
   */
  minHeight?: string;
  /**
   * The video buffering state of the Landing.
   * @type boolean
   * @optional
   */
  isBuffering?: boolean;
  /**
   * The video buffer end event of the Landing.
   * @type () => void
   * @optional
   */
  onBuffer?: () => void;
  /**
   * Enable animation triggered whe the element is visible.
   * @type boolean
   * @optional
   */
  animated?: boolean;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animation?: string;
  /**
  * Mute Video.
   * @type boolean
   * @required
   */
  muted?: boolean;
  /**
  * Blur Video.
   * @type boolean
   * @required
   */
  blurOnLoad?: boolean;
  restrictHeight?: boolean
}

export function LandingDesktop({ minHeight, restrictHeight = true, ...props }: LandingDesktopProps) {
  // const [muted, setMuted] = useState(true);

  // useEffect(() => {
  //   setTimeout(() => {
  //       setMuted(!!props?.muted);
  //   }, 1000)
  // }, [props?.muted])

  return (
    <>
      {/* {props.isBuffering && <LandingSkeleton />} */}
      {/* <LandingSkeleton /> */}

      <Box
        component="div"
        // hAlignContent="center" // commented by naveen to align video placeholder on full screen
        // vAlignContent="center" // commented by naveen to align video placeholder on full screen
        column
        className={classNames("relative text-center hidden1 size-0 bg-interactive-landing-video rounded-top-banner w-full overflow-hidden", {
          "!block !size-auto": !props.isBuffering,
        })}
        data-aos={props.animated ? (props.animation || 'fade-in') : ''}
        style={{ minHeight: minHeight }}
      >
        <Box className={`${props.heading ? 'opacity-40' : ''} h-fit w-full ${restrictHeight ? "!max-h-screen" : ""}`}>
          {/* <Suspense fallback={<p>Loading...</p>}> */}
          <Video
            width="100%"
            height="auto"
            className={"rounded-top-banner"}
            minHeight={minHeight || "300px"}
            videoUrl={props.video}
            mobileVideo={props.mobileVideo}
            controls
            loop
            // playing
            // forcevideo="true"
            // playsinline
            muted={props?.muted}
            onBufferEnd={props.onBuffer}
            pauseable={false}
            autoPlay={true}
            showCustomPlayButton={false}
            style={{ minHeight: minHeight, width: "100%" }}
            posterImage={props?.image?.src}
            poster={props?.image?.src || ""}
            blurOnLoad={props?.blurOnLoad}
          />
          {/* </Suspense> */}
        </Box>
        {props.heading}
      </Box>
    </>
  );
}